var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBocce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 16,
    viewBox: "0 0 59 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3345 13.8048L14.0623 2.25867L14.3445 2H24.1035L24.3387 2.25867L21.6109 13.7813L21.3287 14.04H11.5697L11.3345 13.8048ZM16.1552 3.9518L14.227 12.1117H19.5885L21.4933 3.9518H16.1552Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7043 2.25867L0 13.8048L0.235156 14.04H9.99414L10.2528 13.8048L12.9806 2.25867L12.762 2H3.01L2.7043 2.25867ZM3.62141 9.00766L2.89242 12.1117H8.23047L8.95945 9.00766H3.62141ZM4.8207 3.9518L4.09172 7.03234H9.42977L10.1588 3.9518H4.8207Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3969 2.25867L25.7026 2H35.4616L35.6732 2.25867L35.2734 3.9518H27.5133L25.585 12.1117H33.3216L32.9454 13.8048L32.6867 14.04H22.9277L22.6926 13.7813L25.3969 2.25867Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7314 2.25867L37.0371 2H46.7961L47.0077 2.25867L46.608 3.9518H38.8478L36.9195 12.1117H44.6562L44.2799 13.8048L44.0213 14.04H34.2623L34.0271 13.7813L36.7314 2.25867Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3481 2L48.0424 2.25867L45.3381 13.7813L45.5968 14.04H55.3323L55.5909 13.8048L55.9672 12.1117H48.2306L48.9696 8.98414H55.0501L55.5674 7.00883H49.4364L50.1588 3.9518H57.919L58.3188 2.25867L58.1071 2H48.3481Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBocce);
export default __webpack_public_path__ + "static/media/BOCCE.2b725dd06b8992e38f37a17abf47739c.svg";
export { ForwardRef as ReactComponent };